module.exports = __webpack_public_path__ + "img/ksh.136ce458.png";